<script>
	import { createEventDispatcher, onMount } from 'svelte';
	import { replace } from 'svelte-spa-router';
	import { API, StatusHttp, TipoEvento, limparLocalStorage, TextoFeedback } from '../../utils';
	import TBox from '../templates/TBox.svelte';

	const dispatch = createEventDispatcher();

	let email = "";
	let senha = "";
	let perfil = "";
	let perfis = [];
	let tituloAviso = "Erro";

	onMount(async () => {
		let informacosAPICache = JSON.parse(localStorage.getItem('AVAL_API_INFO_CACHE'));
		perfis = Object.entries(informacosAPICache.perfis).sort();
	});

	async function submeterFormulario() {
		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Aguarde ...',
		});

		// faz a chamada a API no endpoint de login, envia os dados e aguarda a resposta
		const resposta = await fetch(API('credenciais'), {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				email: email.trim(), 
				senha: senha,
				perfilEscolhido: perfil
			})
		}).catch(erros => {
			console.log(erros);

			dispatch('routeEvent', {
				tipo: TipoEvento.ESTA_CARREGANDO,
				valor: false
			});
			
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: tituloAviso,
				conteudo: TextoFeedback.ERRO_REQUISICAO
			});
		});

		const json = await resposta.json();

		if (resposta.status == StatusHttp.OK) {
			
			// verifica inicialmente se token do usuário está bloqueado
			if (json.usuario?.bloqueado == true) {
				dispatch('routeEvent', {
					tipo: TipoEvento.ABRIR_MODAL,
					titulo: 'Acesso bloqueado.',
					conteudo: 'Se este for seu primeiro acesso ao sistema, aguarde enquanto os dados são validados, conforme instruções dadas após realização do cadastro. Caso contrário siga as instruções da página SUPORTE (botão na página incial)'
				});

				limparLocalStorage(true, true, true, true);
				setTimeout( () => replace('/'), 1000);
			} else {
				// guarda o token no navegador do usuário
				sessionStorage.setItem('AVAL_TOKEN', json.jwt.token);

				// salva dados do usuário no cache
				localStorage.setItem('AVAL_USUARIO_DADOS', JSON.stringify(json.usuario));

				// aguarda um pouco antes de redirecionar devido o localstorage levar um tempo pra escrever (síncrono)
				setTimeout(() => {
					// redireciona pro painel do usuário
					replace('/painel');
				}, 1000);
			}

		} else {
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: tituloAviso,
				conteudo: json?.mensagem
			});
		}

		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: false
		});
	}
</script>

<TBox 
	titulo="Login" 
	subtitulo="Insira seus dados para continuar" 
	icone="login">
	
	<form method="post" on:submit|preventDefault={submeterFormulario}>
		<small class="has-text-primary">Perfil de acesso:</small>
		<div class="field">
			<div class="select is-primary is-large is-fullwidth">
				<select bind:value={perfil} name="perfil" required>
					<option value="">Escolha um perfil...</option>
					{#each perfis as [chave, valor]}
					<option value="{chave}">{valor}</option>
					{/each}
				</select>
			</div>
		</div>

		<small class="has-text-primary">E-mail:</small>
		<div class="field">
			<input 
				bind:value={email}
				name="email" 
				type="email" 
				autocomplete="email"
				class="input is-large is-primary" 
				placeholder="Email" required>
		</div>

		<small class="has-text-primary">Senha:</small>
		<div class="field">
			<input 
				bind:value={senha}
				name="senha" 
				type="password" 
				class="input is-large is-primary" 
				placeholder="Senha" required>
		</div>

		<br>

		<div class="columns">
			<div class="column">
				<p class="control">
					<a href="#/" class="button is-black is-outlined is-medium is-fullwidth">Voltar</a>
				</p>
			</div>
			<div class="column is-8">
				<p class="control">
					<button 
						type="submit" 
						class="button is-primary is-medium is-fullwidth">
						Entrar
					</button>
				</p>
			</div>
		</div>

		<div class="has-text-centered">
			<a href="#/usuario/cadastro">Fazer cadastro</a>
			&bull;
			<a href="#/acesso/recuperacao">Recuperar acesso</a>
		</div>
	</form>
</TBox>